import * as React from 'react';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core';

import Container from 'ha/ui/next/Container';
import Grid from 'ha/ui/next/Grid';
import units from 'ha/theme/units';
import CitiesTitle from './CitiesTitle';
import AppartmentsTitle from './AppartmentsTitle';
import RoomsTitle from './RoomsTitle';
import Separator from '../Separator';
import Suggestions from './Suggestions';
import { Suggestion as SuggestionsType } from '../../types';

export const styles = (theme: Theme) =>
  createStyles({
    substrate: {
      backgroundColor: '#f8f9fa',
    },
    section: {
      paddingBottom: units.rem(4.5),
    },
    citiesWrapper: {
      marginBottom: units.rem(2.875),
      marginTop: units.rem(7),
    },
    citiesTitle: {
      fontSize: units.rem(1.875),
    },
    title: {
      fontSize: units.rem(1.875),
      minHeight: units.rem(5),
      marginTop: units.rem(3),
    },
  });

interface Props {
  cities: SuggestionsType[];
  appartments: SuggestionsType[];
  rooms: SuggestionsType[];
}

export const SuggestionsLayout: React.SFC<
  Props & WithStyles<typeof styles>
> = ({ cities, appartments, rooms, classes }) => {
  return (
    <React.Fragment>
      <Grid className={classes.section}>
        <Container maxWidth="lg">
          <CitiesTitle
            wrapperClassName={classes.citiesWrapper}
            titlesClassName={classes.citiesTitle}
          />
          <Grid item container spacing={8}>
            <Suggestions list={cities} columnCount={6} />
          </Grid>
        </Container>
      </Grid>

      <Separator />

      <Grid className={classes.substrate}>
        <Container maxWidth="lg" className={classes.section}>
          <Grid item container spacing={8}>
            <Grid item xs={8}>
              <AppartmentsTitle className={classes.title} />
            </Grid>
            <Grid item xs={4}>
              <RoomsTitle className={classes.title} />
            </Grid>
          </Grid>
          <Grid item container spacing={8}>
            <Suggestions list={appartments} columnCount={4} />
            <Suggestions list={rooms} columnCount={2} />
          </Grid>
        </Container>
      </Grid>
    </React.Fragment>
  );
};

export default withStyles(styles)(SuggestionsLayout);
